import type { ValidationResult } from "@entrilia/shared/utilities/validators";
import { invalidResult, validResult } from "@entrilia/shared/utilities/validators";
import type { ObjectFilter } from "../../api/types/objectTypes";
import { emptyGuid } from "./objectFilterHelpers";

export const validateObjectFilter = (filter: ObjectFilter): ValidationResult => {
  if (!filter.fieldId) {
    return invalidResult("Select a field");
  }

  if (filter.textFilter) {
    const { operator, value, values } = filter.textFilter;
    if (operator === "Empty" || operator === "NotEmpty") {
      return validResult();
    }
    if (operator === "InArray") {
      return values?.length ? validResult() : invalidResult("Select values");
    }
    return value ? validResult() : invalidResult("Enter a value");
  }

  if (filter.numberFilter) {
    const { operator, value, from, to } = filter.numberFilter;
    if (operator === "Empty" || operator === "NotEmpty") {
      return validResult();
    }
    if (operator === "Between") {
      return from !== undefined && to !== undefined ? validResult() : invalidResult("Enter a value");
    }
    if (operator === "GreaterThan" || operator === "GreaterThanOrEquals") {
      return from !== undefined ? validResult() : invalidResult("Enter a value");
    }
    if (operator === "LessThan" || operator === "LessThanOrEquals") {
      return to !== undefined ? validResult() : invalidResult("Enter a value");
    }
    return value !== undefined ? validResult() : invalidResult("Enter a value");
  }

  if (filter.dateFilter) {
    const { operator, from, to } = filter.dateFilter;
    if (operator === "Empty" || operator === "NotEmpty") {
      return validResult();
    }
    return from || to ? validResult() : invalidResult("Enter a value");
  }

  if (filter.booleanFilter) {
    return validResult();
  }

  if (filter.multiSelectFilter) {
    const { operator, selectedValues } = filter.multiSelectFilter;
    if (operator === "Empty" || operator === "NotEmpty") {
      return validResult();
    }
    return selectedValues?.length ? validResult() : invalidResult("Select values");
  }

  if (filter.guidFilter) {
    const values = filter.guidFilter.values?.length
      ? filter.guidFilter.values
      : filter.guidFilter.value && filter.guidFilter.value !== emptyGuid
        ? [filter.guidFilter.value]
        : [];
    return values.length ? validResult() : invalidResult("Enter a value");
  }

  return invalidResult("Unsupported filter type");
};
